import {useFetchMe} from '../../hooks/session/useFetchMe';
import {useSession} from '../../hooks/session/SessionProvider';
import {Box, Card, MenuItem} from '@mui/material';
import Grid from '@mui/material/Grid';
import Select, {SelectChangeEvent} from '@mui/material/Select';
import {getCurrentUser} from 'aws-amplify/auth';
import React, {useCallback, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Outlet, useNavigate} from 'react-router-dom';

import {useCrisp} from '../../components/CrispProvider';
import {i18n} from '../../i18n';

export function Authentication() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const fetchMe = useFetchMe();
  const {refreshSession} = useSession();
  const {crisp} = useCrisp();
  const [authenticationState, setAuthenticationState] = useState({
    lang: i18n.languages[0] as 'de' | 'en' | 'es' | 'fr' | 'it' | 'pt',
  });
  const {lang} = authenticationState;

  const handleChangeLanguage = useCallback(
    (e: SelectChangeEvent<string>) => {
      setAuthenticationState((state) => ({
        ...state,
        lang: e !== null ? (e.target.value as 'de' | 'en' | 'es' | 'fr' | 'it' | 'pt') : 'fr',
      }));
      i18n.changeLanguage(e.target.value);
    },
    [setAuthenticationState, i18n],
  );

  useEffect(() => {
    const callback = () => {
      console.log('i18n.languages', i18n.languages);
      setAuthenticationState((state) => ({
        ...state,
        lang: i18n.languages[0] as 'de' | 'en' | 'es' | 'fr' | 'it' | 'pt',
      }));
    };
    i18n.on('languageChanged', callback);
    getCurrentUser()
      .then(async () => {
        await refreshSession();
        // `refreshSession` invalide aussi le profil : on relit le résultat dans
        // le cache plutôt que de refaire l'appel.
        const me = await fetchMe();
        if (me === undefined || me.vanityName === undefined || me.lnAccessTokenValid !== true) {
          navigate('/auth/linkedin');
        } else {
          navigate('/');
        }
      })
      .catch(() => {
        // do nothing
      });
    crisp.showIcon();
    return () => {
      i18n.off('languageChanged', callback);
    };
  }, []);

  return (
    <Grid container>
      <Grid size={{xs: 11, sm: 8, md: 6, lg: 4, xl: 3}} sx={{mx: 'auto'}}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '100vh',
          }}
        >
          <Card>
            <Outlet context={{lang}} />
          </Card>
        </Box>
        <Box sx={{position: 'fixed', bottom: 0, left: 0, mb: 2, ml: 2}}>
          <Select value={lang} onChange={handleChangeLanguage}>
            <MenuItem disabled value="">
              <em>{t('global.language.placeholder')}</em>
            </MenuItem>
            <MenuItem value="de">{t('global.language.de')}</MenuItem>
            <MenuItem value="en">{t('global.language.en')}</MenuItem>
            <MenuItem value="es">{t('global.language.es')}</MenuItem>
            <MenuItem value="fr">{t('global.language.fr')}</MenuItem>
            <MenuItem value="it">{t('global.language.it')}</MenuItem>
            <MenuItem value="pt">{t('global.language.pt')}</MenuItem>
          </Select>
        </Box>
      </Grid>
    </Grid>
  );
}
